var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class InogeniCam300 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.cmdEnd = '>';
        this.cmdStart = '<';
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand('GET'), /([\d\.]+)/i, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand('POLL'), /(\d)/i, tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`IN${value}`), /(\d)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                return match[1];
            }),
            asyncHandlers: [
                {
                    regExp: /IN\s*(\d+)/i,
                    callback: (match) => {
                        const value = match[1];
                        this.state.videoMatrixRoutes.update('1', value);
                    },
                },
            ],
        };
        // polling
        this.polls = [{ intervalMs: 4000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cmdStart = this.socket.port === 50000 ? '$' : '<';
            this.cmdEnd = this.socket.port === 50000 ? '$' : '>';
            const initializerSteps = [
                {
                    errorCode: 'verifyFailed',
                    send: this.makeCommand('GET'),
                    next: /([\d\.]+)/i,
                },
            ];
            return yield CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
        });
    }
    // other class methods
    makeCommand(cmd) {
        return `${this.cmdStart}${cmd}${this.cmdEnd}`;
    }
}
// static properties
InogeniCam300.driverType = 'socketDriver';
InogeniCam300.key = '-NT9CdTCBDIGVjZ408Jb';
InogeniCam300.baseSocketOptions = {
    sendTerminator: '\r',
};
InogeniCam300.socketOptions = [
    Object.assign(Object.assign({}, InogeniCam300.baseSocketOptions), { port: 50000 }),
    Object.assign(Object.assign({}, InogeniCam300.baseSocketOptions), { port: 4999 }),
];
